import AutoAssign from './AutoAssign'

export default AutoAssign
